import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/Axelerate_logo.svg'
import _imports_1 from '../../assets/illustrationEmail.png'


const _withScopeId = n => (_pushScopeId("data-v-d3f9ae9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center rounded bg-background" }
const _hoisted_2 = { class: "flex flex-col bg-white lg:shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-lg w-full max-w-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-5 pb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "login logo",
    class: "w-5/12 lg:pb-5"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "illustration",
    class: "w-5/12 lg:pb-5"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold self-start text-xl sm:text-2xl text-gray" }, " New password ", -1))
const _hoisted_5 = { class: "mt-10" }
const _hoisted_6 = { class: "flex flex-col mb-6" }
const _hoisted_7 = { class: "relative z-0 w-full mb-2" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "flex flex-col mb-6" }
const _hoisted_10 = { class: "relative z-0 w-full mb-2" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = { class: "flex w-full" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordField = _resolveComponent("PasswordField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_PasswordField, {
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                  label: "New password",
                  name: "password"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_PasswordField, {
                  modelValue: _ctx.confirm,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirm) = $event)),
                  label: "Confirm new password",
                  name: "password_confirmation"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "submit",
              disabled: !_ctx.meta.dirty || !_ctx.meta.valid,
              class: "flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-primary rounded-full py-2 w-full transition duration-150 ease-in h-14 btn-submit"
            }, " Save new password ", 8, _hoisted_13)
          ])
        ], 32)
      ])
    ])
  ]))
}